import type { EventType } from '@/domain';
import type { BaselineResolution } from './historical-aggregator';

/**
 * Pure function: apply monthly + event multipliers to baseline.
 *   forecast_qty = round(baseline_avg * monthly[month] * event[event_type])
 */

export interface GenerateInput {
  baseline: BaselineResolution;
  monthly_multiplier: number; // ≥ 0, e.g. 1.0 for May, 1.4 for Nov
  event_multiplier: number; // ≥ 0, e.g. 1.0 NORMAL, 4.5 MEGA_SALE
}

export interface GenerateOutput {
  forecast_qty: number;
  raw_qty: number; // pre-rounding
  baseline_avg: number;
  monthly_multiplier: number;
  event_multiplier: number;
  resolved_event_type: EventType;
  fallback_used: boolean;
  p85: number | null; // after multipliers
  sample_size: number;
}

export function generate(input: GenerateInput): GenerateOutput {
  const mm = Math.max(0, input.monthly_multiplier);
  const em = Math.max(0, input.event_multiplier);
  const baseAvg = Math.max(0, input.baseline.stats.avg);
  const raw = baseAvg * mm * em;
  const p85 =
    input.baseline.stats.p85 > 0 ? input.baseline.stats.p85 * mm * em : null;
  return {
    forecast_qty: Math.round(raw),
    raw_qty: raw,
    baseline_avg: baseAvg,
    monthly_multiplier: mm,
    event_multiplier: em,
    resolved_event_type: input.baseline.resolved_type,
    fallback_used: input.baseline.fallback_used,
    p85,
    sample_size: input.baseline.stats.n,
  };
}
